import React, { useState } from 'react';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import CSSZSickLeaveCertificateEmploymentItem from './CSSZSickLeaveCertificateEmploymentItem';
import styles from './CSSZSickLeaveCertificateEmployment.module.scss';
import { useEffectAsync } from '../../../../helpers';
import useApiClient from '../../../Base/Hooks/useApiClient';
import apiClient from '../../../../Services/ApiClient';
import useLoading from '../../../Base/Hooks/useLoading';
import { CSSZEmployerData } from '../../Interfaces/CSSZ.interface';

interface Props {
	patientId: string;
	onSelect: (item: CSSZEmployerData) => void;
	onClose: () => void;
}

const CSSZSickLeaveCertificateEmployment: React.FC<Props> = ({
	patientId,
	onSelect,
	onClose,
}) => {
	const [employers, setEmployers] = useState<CSSZEmployerData[]>([]);
	const { setIsLoading, isLoading, RenderLoading } = useLoading(true);
	const { displayError } = useApiClient();

	useEffectAsync(async () => {
		setIsLoading(true);
		try {
			const response = await apiClient.get(
				`/user/${patientId}/cssz/dpn-vrat-zamestnavatele-pojistence`,
			);
			if (response.status === 200) {
				setEmployers(response.data as CSSZEmployerData[]);
			}
		} catch (e) {
			displayError(e);
		}
		setIsLoading(false);
	}, []);

	if (isLoading) {
		return <RenderLoading />;
	}

	return (
		<div>
			<div className={styles.wrapper}>
				{employers.map(item => (
					<CSSZSickLeaveCertificateEmploymentItem
						item={item}
						onSelect={onSelect}
					/>
				))}
				<LinkButton
					title='component.CSSZSickLeaveCertificateWrapper.manualEntryInstead'
					onClick={onClose}
					theme={Theme.BLUE}
				/>
			</div>
		</div>
	);
};

export default CSSZSickLeaveCertificateEmployment;
